import { useMemo } from "react";
import { useRouter } from "next/router";
import { parseQueryObject } from "../../../lib";
import { useFetchTile } from "../profile-page/api";
import { LAST_TILE_ID } from "../profile-page/profile-page";
import { isMongoId, isTileId } from "@ecologi/shared";

function useTileNavigation(userId: string) {
  const router = useRouter();

  const normalisedTileQuery = useMemo(() => {
    const query = parseQueryObject(router.query);
    const value = query.tileId || query.treeId || query.tree;

    return parseInt(value) ||
      isMongoId(value) ||
      isTileId(value) ||
      value === LAST_TILE_ID
      ? value
      : null;
  }, [router.query]);

  const tileResult = useFetchTile(userId, normalisedTileQuery, {
    enabled:
      userId && normalisedTileQuery && normalisedTileQuery !== LAST_TILE_ID,
  });

  return {
    tileId: tileResult.data?._id,
    normalisedTileQuery,
  };
}

export default useTileNavigation;
